import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Input,
  Stack,
  Text,
  VStack,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { BiLowVision, BiShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import logo from "../../assets/logo.png";
import {
  facultiesAction,
  signupUserAction,
  yearsAction,
} from "../../modules/auth/Actions";
import { getGovernoratesRequest, getMajorsRequest, getGradesRequest, getUserGroupsRequest } from "../../modules/user/Actions";
import { getAllSubjectsRequest } from "../../modules/admin-modules/subjects/Actions";
import PublicLayout from "../public/Layout/layout";
const SignupForm = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.auth.isLoading);
  const years = useSelector((state) => state.auth.years);
  const faculties = useSelector((state) => state.auth.faculties);
  const governorates = useSelector((state) => state.user.governorates);
  const majors = useSelector((state) => state.user.majors);
  const grades = useSelector((state) => state.user.grades);
  const subjects = useSelector((state) => state.subjects.subjects);
  const groups = useSelector((state) => state.user.groups);
  const navigate = useNavigate();
  const [inputType, setInputType] = useState("password");
  const [selectedSubject, setSelectedSubject] = useState(null);

  const yearsOptions = years?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const facultiesOptions = faculties?.map((data) => {
    return { value: data.id, label: data.name };
  });
  useEffect(() => {
    dispatch(yearsAction());
    dispatch(facultiesAction());
    dispatch(getGovernoratesRequest());
    dispatch(getMajorsRequest());
    dispatch(getGradesRequest());
    dispatch(getAllSubjectsRequest());
  }, []);

  useEffect(() => {
    dispatch(getUserGroupsRequest(selectedSubject));
  }, [selectedSubject]);

  const governoratesOptions = governorates?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const majorsOptions = majors?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const gradesOptions = grades?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });
  
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" }
  ];
  
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const validateUserName = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  const validatePhone = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  const validatePassword = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }

    return error;
  };

  const validateConfirmPassword = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  const validateYear = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };

  const validateParentPhone = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };

  const validateNationalId = (value) => {
    let error;
    if (value && value!=="" &&value.length !== 14) {
      error = "National ID must be 14 digits";
    }
    return error;
  };

  const validateGovernorate = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };

  const validateSchool = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };

  const validateMajor = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };

  const validateGender = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };

  const validateSubjectId = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };

  const validateStudentGroupId = (value) => {
    let error;
    if (!value) {
      error = "Required";
    }
    return error;
  };
  return (
    <PublicLayout color="main_1" bg="white" register={false}>
      <Flex
        flexDirection="column"
        alignItems="center"
        my="50px"
        w="100%"
        h="100%"
      >
        <Formik
          initialValues={{
            name: "",
            phone: "",
            email: "",
            password: "",
            password_confirmation: "",
            parent_phone: "",
            national_id: "",
            governorate: "",
            school: "",
            year_id: "",
            major_id: "",
            faculty_id: "",
            gender: "",
            referral_code: "",
            subject_id: "",
            student_group_id: "",
          }}
          onSubmit={(values) => {
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("phone", values.phone);
            formData.append("email", values.email);
            formData.append("password", values.password);
            formData.append("password_confirmation", values.password_confirmation);
            formData.append("parent_phone", values.parent_phone);
            formData.append("national_id", values.national_id);
            formData.append("governorate_id", values.governorate);
            formData.append("school", values.school);
            formData.append("year_id", values.year_id);
            formData.append("major_id", values.major_id);
            formData.append("faculty_id", values.faculty_id);
            formData.append("gender", values.gender);
            formData.append("referral_code", values.referral_code);
            formData.append("subject_id", values.subject_id);
            formData.append("student_group_id", values.student_group_id);

            dispatch(
              signupUserAction(formData, () => {
                navigate("/otp");
              })
            );
            
          }}
        >
          {({ setValues, errors, touched, values, setFieldValue }) => (
            <Form
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{ width: { base: "95%", md: "80%", lg: "70%" } }}
                bg="white"
                borderRadius="20px"
                boxShadow="0 10px 30px rgba(0, 0, 0, 0.1)"
                p="40px"
              >
                <center>
                  <img
                    src={logo}
                    alt="bstudy logo"
                    style={{ width: "40%" }}
                  />
                </center>
                <Text textAlign="center" fontSize="18px" mt="15px" color="gray.600">
                  Powered by Asquera
                </Text>
                <br />
                <Heading textAlign={"center"} mb="30px" color="main_1" fontSize="32px">
                  Create Your Account
                </Heading>

                <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={6}>
                  {/* Name */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="name"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Full Name *
                      </FormLabel>
                      <Field
                        as={Input}
                        name="name"
                        validate={validateUserName}
                        placeholder="Enter your full name"
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="12px"
                        _focus={{
                          borderColor: "main_1",
                          boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                      {errors.name && touched.name && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.name}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* Phone */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="phone"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Phone Number *
                      </FormLabel>
                      <Field
                        as={Input}
                        name="phone"
                        type="text"
                        validate={validatePhone}
                        placeholder="Enter your phone number"
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="12px"
                        _focus={{
                          borderColor: "main_1",
                          boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                      <Text fontSize="12px" color="gray.600" mt="4px">
                        Tip: Add 00 before Gulf numbers (009xxxx), Egyptian numbers without additions (012345)
                      </Text>
                      {errors.phone && touched.phone && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.phone}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* Email */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="email"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Email Address
                      </FormLabel>
                      <Field
                        as={Input}
                        name="email"
                        type="email"
                        placeholder="Enter your email address"
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="12px"
                        _focus={{
                          borderColor: "main_1",
                          boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                    </Box>
                  </GridItem>

                  {/* Parent Phone */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="parent_phone"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Parent Phone Number *
                      </FormLabel>
                      <Field
                        as={Input}
                        name="parent_phone"
                        type="text"
                        validate={validateParentPhone}
                        placeholder="Enter parent's phone number"
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="12px"
                        _focus={{
                          borderColor: "main_1",
                          boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                      {errors.parent_phone && touched.parent_phone && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.parent_phone}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* National ID */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="national_id"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        National ID (Optional)
                      </FormLabel>
                      <Field
                        as={Input}
                        name="national_id"
                        type="text"
                        validate={validateNationalId}
                        placeholder="Enter your 14-digit national ID"
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="12px"
                        _focus={{
                          borderColor: "main_1",
                          boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                      {errors.national_id && touched.national_id && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.national_id}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* Governorate */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="governorate"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Governorate *
                      </FormLabel>
                      <Select
                        options={governoratesOptions}
                        onChange={(data) => {
                          setFieldValue("governorate", data.value);
                        }}
                        styles={colourStyles}
                        placeholder="Select your governorate"
                      />
                      {errors.governorate && touched.governorate && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.governorate}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* School */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="school"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Faculty *
                      </FormLabel>
                      <Field
                        as={Input}
                        name="school"
                        type="text"
                        validate={validateSchool}
                        placeholder="Enter your faculty name"
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="12px"
                        _focus={{
                          borderColor: "main_1",
                          boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                      {errors.school && touched.school && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.school}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* Year */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="year_id"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Academic Year *
                      </FormLabel>
                      <Select
                        options={gradesOptions}
                        onChange={(data) => {
                          setFieldValue("year_id", data.value);
                        }}
                        styles={colourStyles}
                        placeholder="Select your academic year"
                      />
                      {errors.year_id && touched.year_id && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.year_id}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* Major */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="major"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Major (شعبة الثانوية العامة)*
                      </FormLabel>
                      <Select
                        options={majorsOptions}
                        onChange={(data) => {
                          setFieldValue("major_id", data.value);
                        }}
                        styles={colourStyles}
                        placeholder="Select your major/field of study"
                      />
                      {errors.major_id && touched.major_id && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.major_id}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* Gender */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="gender"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Gender *
                      </FormLabel>
                      <Select
                        options={genderOptions}
                        onChange={(data) => {
                          setFieldValue("gender", data.value);
                        }}
                        styles={colourStyles}
                        placeholder="Select your gender"
                      />
                      {errors.gender && touched.gender && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.gender}
                        </Text>
                      )}
                    </Box>
                  </GridItem>
                </Grid>

                {/* Subject and Student Group Row */}
                <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={6} mt="30px">
                  {/* Subject */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="subject_id"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        University *
                      </FormLabel>
                      <Select
                        options={subjectsOptions}
                        onChange={(data) => {
                          setFieldValue("subject_id", data.value);
                          setSelectedSubject(data.value);
                        }}
                        styles={colourStyles}
                        placeholder="Select University"
                      />
                      {errors.subject_id && touched.subject_id && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.subject_id}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* Student Group */}
                  <GridItem>
                    <Box>
                      <FormLabel
                        htmlFor="student_group_id"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Faculty and Year *
                      </FormLabel>
                      <Select
                        options={groupsOptions}
                        onChange={(data) => {
                          setFieldValue("student_group_id", data.value);
                        }}
                        styles={colourStyles}
                        placeholder="Select Faculty and Year"
                      />
                      {errors.student_group_id && touched.student_group_id && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.student_group_id}
                        </Text>
                      )}
                    </Box>
                  </GridItem>
                </Grid>

                {/* Referral Code */}
                <Box mt="30px">
                  <FormLabel
                    htmlFor="referral_code"
                    color={"main_1"}
                    fontSize="16px"
                    fontWeight="600"
                    mb="8px"
                  >
                    Referral Code
                  </FormLabel>
                  <Field
                    as={Input}
                    name="referral_code"
                    type="text"
                    placeholder="Enter referral code (optional)"
                    bg="gray.50"
                    border="2px solid"
                    borderColor="gray.200"
                    borderRadius="12px"
                    _focus={{
                      borderColor: "main_1",
                      boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                    }}
                    _hover={{
                      borderColor: "gray.300"
                    }}
                  />
                  <Text fontSize="12px" color="gray.600" mt="4px">
                    Enter a referral code if you have one
                  </Text>
                </Box>

                <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={6} mt="30px">
                  {/* Password */}
                  <GridItem>
                    <Box position="relative">
                      <FormLabel
                        htmlFor="password"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Password *
                      </FormLabel>
                      <Field
                        as={Input}
                        name="password"
                        validate={validatePassword}
                        type={inputType}
                        placeholder="Enter your password"
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="12px"
                        pr="50px"
                        _focus={{
                          borderColor: "main_1",
                          boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                      <Icon
                        position="absolute"
                        right="15px"
                        top="40px"
                        fontSize="20px"
                        color="main_1"
                        cursor="pointer"
                        as={inputType === "password" ? BiShow : BiLowVision}
                        onClick={() =>
                          inputType === "password"
                            ? setInputType("text")
                            : setInputType("password")
                        }
                      />
                      {errors.password && touched.password && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.password}
                        </Text>
                      )}
                    </Box>
                  </GridItem>

                  {/* Confirm Password */}
                  <GridItem>
                    <Box position="relative">
                      <FormLabel
                        htmlFor="password_confirmation"
                        color={"main_1"}
                        fontSize="16px"
                        fontWeight="600"
                        mb="8px"
                      >
                        Confirm Password *
                      </FormLabel>
                      <Field
                        as={Input}
                        name="password_confirmation"
                        validate={validateConfirmPassword}
                        type={inputType}
                        placeholder="Confirm your password"
                        bg="gray.50"
                        border="2px solid"
                        borderColor="gray.200"
                        borderRadius="12px"
                        pr="50px"
                        _focus={{
                          borderColor: "main_1",
                          boxShadow: "0 0 0 1px var(--chakra-colors-main-1)"
                        }}
                        _hover={{
                          borderColor: "gray.300"
                        }}
                      />
                      <Icon
                        position="absolute"
                        right="15px"
                        top="40px"
                        fontSize="20px"
                        color="main_1"
                        cursor="pointer"
                        as={inputType === "password" ? BiShow : BiLowVision}
                        onClick={() =>
                          inputType === "password"
                            ? setInputType("text")
                            : setInputType("password")
                        }
                      />
                      {errors.password_confirmation && touched.password_confirmation && (
                        <Text color="red.500" fontSize="14px" mt="4px">
                          {errors.password_confirmation}
                        </Text>
                      )}
                    </Box>
                  </GridItem>
                </Grid>

                <Flex justifyContent="center" mt="40px">
                  <Button
                    type="submit"
                    size="lg"
                    px="50px"
                    py="25px"
                    isLoading={isLoading}
                    loadingText="Creating Account..."
                    bg="main_1"
                    color="white"
                    borderRadius="12px"
                    fontSize="18px"
                    fontWeight="600"
                    _hover={{
                      bg: "main_1",
                      transform: "translateY(-2px)",
                      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)"
                    }}
                    _active={{
                      transform: "translateY(0px)"
                    }}
                    transition="all 0.2s"
                  >
                    Create Account
                  </Button>
                </Flex>

                <Text textAlign="center" mt="30px" fontSize="16px" color="gray.600">
                  Already have an account?{" "}
                  <Text
                    as="a"
                    href="/"
                    color="main_1"
                    fontWeight="600"
                    textDecoration="underline"
                    _hover={{
                      color: "main_1",
                      textDecoration: "none"
                    }}
                  >
                    Sign In
                  </Text>
                </Text>
              </Box>
            </Form>
          )}
        </Formik>
      </Flex>
    </PublicLayout>
  );
};

export default SignupForm;
